import React from 'react';
import styled from 'styled-components';

interface ZoomContainerProps {
    $zoom: number;
}

export const ZoomContainer = styled.div<ZoomContainerProps>`
    -moz-transform: ${props => `scale(${props.$zoom / 100})`};
    -moz-transform-origin: 0 0;
    zoom: ${props => (props.$zoom ? `${props.$zoom}%` : '100%')};
    width: ${props => (props.$zoom ? `${props.$zoom}%` : '100%')};

    transition: all 0.02s;

    *:not(p, h1, h2, h3) {
        transition: all 0.02s;
    }
`;
